import {createStore, applyMiddleware, compose as origCompose, combineReducers} from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk/es/index.js';
import userManager from '@/shared/utils/userManager';
import {createOidcMiddleware, reducer as oidcReducer} from '@sdb-develop/learning-redux-oidc-es6';
import {connectStsSignOut} from '@/auth/stsSignOut';
import {lazyReducerEnhancer} from 'pwa-helpers/lazy-reducer-enhancer.js';
import promiseMiddleware from 'redux-promise-middleware';
import minervaSettings from '@/app/reducers/minervaSettings.js';
import learningPlan from '@/learningplan/reducers/learningplan.js';
import learningPlanInfo from '@/learningplan/reducers/learningplanInfo.js';
import learningPath from '@/learningpath/reducers/learningpath.js';
import workflow from '@/learningplan/reducers/workflow.js';
import digitalLearning from '@/learningplan/reducers/digitallearning.js';
import catalogItem from '@/catalog/reducers/catalogItem.js';
import costregistration from '@/costregistration/reducers/costregistration.js';
import scormResult from './scorm/reducers/scorm-result.js';
import scorm from './scorm/reducers/scorm.js';
import catalog from '@/catalog/reducers/catalog.js';
import planningReport from '@/reports/reducers/planningReport.js';
import signIn from '@/auth/reducers/signin.js';
import adminCatalog from '@/catalog/reducers/adminCatalog.js';
import assignmentCatalog from '@/catalog/reducers/assignmentCatalog.js';
import ReduxAsyncQueue from 'redux-async-queue/es/index.js';
import skillsSettings from '@/skills/reducers/skillsSettings.js';
import trainingsSettings from '@/training/reducers/trainingsSettings.js';
import accreditation from '@/accreditation/reducers/accreditation.js';
import accreditationInfo from '@/accreditation/reducers/accreditationInfo.js';
import registration from '@/classroom/reducers/registration.js';
import classroom from '@/classroom/reducers/classroom.js';
import skillsTargetIdMap from '@/skills/reducers/skillsTargetIdMap.js';
import exportReducer from '@/administration/import-export/reducers/export.js';

// import consumer from './reducers/consumer.js';
// import startLti from './reducers/startLti.js';

import mySaga from '@/app/sagas/rootSaga.js';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || origCompose;

export const store = createStore(
    (state) => state,
    compose(
        lazyReducerEnhancer(combineReducers),
        applyMiddleware(
            sagaMiddleware,
            createOidcMiddleware(userManager),
            thunk,
            ReduxAsyncQueue,
            promiseMiddleware,
        ),
    ),
);

store.addReducers({
    signIn: signIn,
    oidc: oidcReducer,
    minervaSettings: minervaSettings,
    learningPlan: learningPlan,
    learningPlanInfo: learningPlanInfo,
    learningPath: learningPath,
    workflow: workflow,
    digitalLearning: digitalLearning,
    catalogItem: catalogItem,
    costregistration: costregistration,
    scormResult: scormResult,
    scorm: scorm,
    catalog: catalog,
    planningReport: planningReport,
    adminCatalog: adminCatalog,
    assignmentCatalog: assignmentCatalog,
    skillsSettings: skillsSettings,
    trainingsSettings: trainingsSettings,
    accreditation: accreditation,
    accreditationInfo: accreditationInfo,
    registration: registration,
    classroom: classroom,
    skillsTargetIdMap: skillsTargetIdMap,
    export: exportReducer,
});

sagaMiddleware.run(mySaga);
connectStsSignOut(userManager, store.dispatch);
